import React,{useState,useContext} from 'react'
import {UserContext} from '../../App'
import {Link,useHistory} from 'react-router-dom'
import M from 'materialize-css'
import { API } from '../../api'

const Signin = () =>{
    const {dispatch} = useContext(UserContext)
    const history =  useHistory("")
    const [password,setPassword] = useState("")
    const [email,setEmail] = useState("")
    const PostData = ()=>{
        fetch(`${API}/signin`,{
            method:"post",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({
                password:password,
                email:email
            })
        }).then(res=>
            res.json()
            )
        .then(data=>{
            console.log(data)
           if(data.error){
               M.toast({html:data.error,classes:"#b71c1c red darken-4"})
           }
           else{
               localStorage.setItem("jwt",data.token)
               localStorage.setItem("user",JSON.stringify(data.user))
              dispatch({type:"USER",payload:data.user})
               M.toast({html:"signedin sucssess",classes:"#43a047 green darken-1"})
               history.push('/')
           }
        })
    }
    return(
        <div className="mycard">
            <div className="card auth-card input-field">
                <h2 className="brand-logo">Minsta</h2>
                <input  className="brand-logo" type="text" placeholder="email"  value={email} onChange={(e)=>setEmail(e.target.value)}></input>
                <input className="brand-logo" type="password" placeholder="password"  value={password} onChange={(e)=>setPassword(e.target.value)}></input>
                <button className="btn waves-effect waves-light brand-logo" onClick={()=>PostData()}>Signin
                 </button>
                 <h6 className="brand-logo"><Link to="/signup">Need an Account?</Link></h6>
            </div>
        </div>
    )
}

export default Signin